import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.direction)
  }, [
    (!_ctx.$route.meta.hideNavbar)
      ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (!_ctx.$route.meta.hideFooter)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2))
}